module.exports = __webpack_public_path__ + "static/media/printer.13f0bc38.png";